import { Component, OnInit } from "@angular/core";
import { TurnosService } from "../../../services/employees/turnos.service";
import moment from "moment";
import { Subject } from "rxjs";
import { CalendarView } from "angular-calendar";

@Component({
    selector: "app-turnos-calendario",
    templateUrl: "./calendario.component.html",
    styleUrls: ["./calendario.component.scss"],
    standalone: false
})
export class TurnosCalendarioComponent implements OnInit {
    // #region Propiedades del componente
    activeDayIsOpen: boolean = false;
    refresh = new Subject<void>();
    viewDate: Date = new Date();
    viewDay: Date = new Date();
    view: CalendarView = CalendarView.Month;
    // #endregion

    constructor(public TurnosService: TurnosService) {}

    ngOnInit(): void {
        this.cargarDatosMesActual();
    }

    // #region Métodos del componente

    cargarDatosMesActual(): void {
        const inicioMes = moment(this.viewDate).startOf('month').format('DD-MM-YYYY');
        const finMes = moment(this.viewDate).endOf('month').format('DD-MM-YYYY');
        this.TurnosService.getListaDiasTrabajo(inicioMes, finMes);
    }

    mesAnterior(): void {
        //this.viewDate = moment(this.viewDate).subtract(1, 'month').toDate();
        this.cargarDatosMesActual();
    }

    mesSiguiente(): void {
        //this.viewDate = moment(this.viewDate).add(1, 'month').toDate();
        this.cargarDatosMesActual();
    }

    closeOpenMonthViewDay() {
        this.activeDayIsOpen = false;
    }

    dayClicked({ date, events }: { date: Date; events: any[] }): void {

        // En el caso de que el día seleccionado sea el mismo que el día actual, se cierra el día
        if (moment(date).isSame(moment(this.viewDay), 'day')) {
            this.viewDay = null;
            this.closeOpenMonthViewDay();
        } else {
            this.viewDay = date;
            this.activeDayIsOpen = true;
        }
    }

    handleEvent(action: string, event: any): void {
    }

    // #endregion
  public trackByIndex(i: number) { return i; }

}
